import type { Component } from 'solid-js';

type Props = {
  class?: string;
  title?: string;
};

/** Compact, code-native version of the ChorePop app mark. */
export const ChorePopMark: Component<Props> = (props) => (
  <svg
    class={props.class}
    viewBox="0 0 512 512"
    role={props.title ? 'img' : undefined}
    aria-hidden={props.title ? undefined : 'true'}
    aria-label={props.title}
  >
    <rect width="512" height="512" rx="112" fill="#fff7e8" />
    <path d="M98 111l15 29 32 5-23 22 6 32-30-15-29 15 5-32-23-22 32-5z" fill="#f2b632" />
    <circle cx="417" cy="122" r="18" fill="#ef6a57" />
    <path d="M392 192l29-26" stroke="#67b34d" stroke-width="18" stroke-linecap="round" />
    <path d="M83 246l-31-15" stroke="#65b9f4" stroke-width="18" stroke-linecap="round" />
    <g stroke="#142c4c" stroke-width="18" stroke-linejoin="round">
      <path d="M147 211h220l-23 198H170z" fill="#2d8fe5" />
      <path d="M126 203h263v54H126z" fill="#65b9f4" />
      <path d="M219 238v83c0 24 19 43 43 43s43-19 43-43v-83" fill="none" />
    </g>
    <g transform="rotate(-7 259 171)">
      <rect
        x="169"
        y="72"
        width="183"
        height="209"
        rx="30"
        fill="#fff"
        stroke="#142c4c"
        stroke-width="18"
      />
      <path
        d="M208 153l28 28 68-72"
        fill="none"
        stroke="#67b34d"
        stroke-width="22"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M210 218h100" stroke="#142c4c" stroke-width="16" stroke-linecap="round" />
    </g>
    <circle cx="378" cy="370" r="45" fill="#f2b632" stroke="#142c4c" stroke-width="16" />
  </svg>
);
